import theme from '@/src/config/theme'
import styled from 'styled-components'
import {Swiper as LibSwiper} from 'swiper/react'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  & .swiper-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  & .swiper-slide {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    & img {
      max-height: 100%;
    }
  }

  & .thumbs .swiper-slide {
    cursor: pointer;

    opacity: 0.5;
    max-width: 135px;

    & img {
      width: 95px;
      height: 95px;
      object-fit: contain;
      max-width: 100%;
    }
  }

  & .thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }
  
  & .swiper-button-next::after,
  & .swiper-button-prev::after {
    display: none;
    content: '';
  }
`

export const MainContainer = styled.div`
  height: 315px;
  min-width: 0;

  .swiper,
  .swiper-wrapper,
  .swiper-slide {
    height: 315px;
  }

  .gallery-image {
    width: 315px;
    height: 315px;
    max-width: 100%;
    object-fit: contain;
  }
`

export const ThumbsContainer = styled.div`
  height: 95px;
  min-width: 0;

  & .swiper,
  & .swiper-wrapper,
  & .swiper-slide {
    height: 95px;
  }
`

export const Swiper = styled(LibSwiper)`
  --swiper-navigation-color: ${theme.colors.gray};
  --swiper-pagination-color: ${theme.colors.gray};
`
